module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Timeline', {
    attrs: {
      "steps": _vm.timelineSteps
    }
  }), _vm._v(" "), (_vm.isAddonBooking) ? _c('h1', [_vm._v("Snart dags för din semester!")]) : _c('h1', [_vm._v("Snart är din semester bokad!")]), _vm._v(" "), _c('p', {
    staticClass: "ingress"
  }, [_vm._v("Gör den mer bekväm med våra tillval:")]), _vm._v(" "), _c('div', {
    staticClass: "bg-color-faded"
  }, [_c('div', {
    staticClass: "addons"
  }, [_c('h2', {
    staticClass: "center"
  }, [_vm._v("BOKA TILLVAL TILL ERT BOENDE")]), _vm._v(" "), (true) ? _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "1em"
    }
  }, [_vm._v("En barnsäng och barnstol ingår alltid i våra boenden.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.addons), function(addon) {
    return (!addon.hide_for_guest) ? _c('div', {
      class: 'addon center ' + (addon.added ? 'selected' : '') + ' ' + (addon.auto === 'T' ? 'auto' : ''),
      attrs: {
        "title": (_vm.$store.state.isDebugging) ? addon.lid : ''
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.chooseArticle(addon)
        }
      }
    }, [_c('div', {
      staticClass: "addon-image default-image",
      style: (addon.image ? 'background-image:url(https://static.booking.branasgruppen.se/static/svg/addons/' + addon.image + ');' : 'background-size: cover;'),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.infoPopup(addon)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "info-blue",
        "scale": 0.9
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "addon-content"
    }, [_c('b', [_vm._v(_vm._s(addon.arttext))]), _vm._v(" "), _c('p', [_c('span', {
      staticStyle: {
        "font-weight": "700"
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(((
      (addon.rut && (_vm.$store.state.cart.ssn || !addon.added))
    ) ? (parseFloat(addon.curraprice) * 0.5) : addon.curraprice))))]), (!addon.rut && !addon.single_count && addon.max_qty > 1) ? _c('span', [_vm._v("/st")]) : _vm._e(), _vm._v(" "), ((
      (addon.rut && (_vm.$store.state.cart.ssn || !addon.added))
    )) ? _c('span', {
      staticClass: "with-rut"
    }, [_vm._v("med RUT-avdrag")]) : _vm._e()]), _vm._v(" "), (addon.auto !== 'T') ? _c('div', {
      staticClass: "input-wrapper",
      staticStyle: {
        "text-align": "left"
      }
    }, [(!addon.added && addon.max_qty > 1 && !addon.single_count) ? _c('span', {
      staticClass: "quantity",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addon.qtySelected),
        expression: "addon.qtySelected"
      }],
      attrs: {
        "type": "number",
        "min": addon.min_qty,
        "max": addon.max_qty
      },
      domProps: {
        "value": (addon.qtySelected)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(addon, "qtySelected", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("st")])]) : _vm._e(), _vm._v(" "), (addon.added) ? _c('button', {
      class: 'small ' + (addon.added ? 'green' : '') + '',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeArticle(addon)
        }
      }
    }, [(addon.max_qty > 1 && !addon.single_count) ? _c('span', [_vm._v("\n                " + _vm._s(addon.qtySelected) + "st valda\n              ")]) : _c('span', [_vm._v("\n                Vald\n              ")])]) : _vm._e(), _vm._v(" "), (addon.added) ? _c('button', {
      class: 'small trash border',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeArticle(addon)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.3
      }
    })], 1) : _vm._e(), _vm._v(" "), (!addon.added) ? _c('button', {
      class: {
        small: true, disabled: !addon.qtySelected
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.chooseArticle(addon)
        }
      }
    }, [_vm._v("Välj")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (addon.auto === 'T') ? _c('div', {
      staticClass: "input-wrapper",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('button', {
      class: 'small ' + 'green' + ' non-clickable'
    }, [_c('span', [_vm._v("\n                " + _vm._s(addon.autoText || 'Obligatoriskt') + "\n              ")])])]) : _vm._e()])]) : _vm._e()
  }), 0)]), _vm._v(" "), (_vm.groceryBags.length) ? _c('div', {
    staticClass: "addons grocery-bags"
  }, [_c('h2', {
    staticClass: "center"
  }, [_vm._v("GÖR DIN RESA ÄNNU MER BEKVÄM")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.groceryBags), function(addon) {
    return _c('div', {
      class: 'addon center ' + (addon.added ? 'selected' : ''),
      attrs: {
        "title": (_vm.$store.state.isDebugging) ? addon.lid : ''
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleArticle(addon)
        }
      }
    }, [_c('div', {
      staticClass: "addon-image default-image",
      style: (addon.image ? 'background-image:url(https://static.booking.branasgruppen.se/static/svg/addons/' + addon.image + ');' : 'background-size: cover;'),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.infoPopup(addon)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "addon-content"
    }, [_c('h2', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.infoPopup(addon)
        }
      }
    }, [_vm._v(_vm._s(addon.arttext) + "  "), _c('icon', {
      attrs: {
        "name": "info-blue",
        "scale": 1
      }
    })], 1), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('p', [_c('span', {
      staticStyle: {
        "font-weight": "700",
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(addon.curraprice)))]), _vm._v("/st")]), _vm._v(" "), _c('div', {
      staticClass: "input-wrapper",
      staticStyle: {
        "text-align": "center"
      }
    }, [(!addon.added && addon.max_qty > 1 && !addon.single_count) ? _c('span', {
      staticClass: "quantity",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addon.qtySelected),
        expression: "addon.qtySelected"
      }],
      attrs: {
        "type": "number",
        "min": addon.min_qty,
        "max": addon.max_qty
      },
      domProps: {
        "value": (addon.qtySelected)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(addon, "qtySelected", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("st")])]) : _vm._e(), _vm._v(" "), (addon.added) ? _c('button', {
      class: 'small ' + (addon.added ? 'green' : '') + '',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeArticle(addon)
        }
      }
    }, [_c('span', [_vm._v("\n                Vald\n              ")])]) : _vm._e(), _vm._v(" "), (addon.added) ? _c('button', {
      class: 'small trash border',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeArticle(addon)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.3
      }
    })], 1) : _vm._e(), _vm._v(" "), (!addon.added) ? _c('button', {
      class: {
        small: true, disabled: !addon.qtySelected
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.chooseArticle(addon)
        }
      }
    }, [_vm._v("Välj")]) : _vm._e()])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.lateArrivalObject) ? _c('div', {
    staticClass: "center spacing"
  }, [_c('div', {
    staticClass: "late-arrival"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_c('b', [_vm._v("\n            Sen ankomst\n            "), _c('span', {
    staticStyle: {
      "position": "relative",
      "top": "-2px",
      "left": "5px",
      "cursor": "pointer",
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        return _vm.openLateCheckinInfo()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1
    }
  })], 1)]), _vm._v(" "), _c('span', [_vm._v("Sen incheckning, efter kl " + _vm._s(_vm.lateArrivalTime) + ".")])]), _vm._v(" "), _c('p', {
    staticClass: "checkboxes"
  }, [_c('Checkbox', {
    class: {
      error: _vm.markLate
    },
    attrs: {
      "label": "JA",
      "label-position": "after",
      "value": true,
      "valuebinder": _vm.lateArrival
    },
    on: {
      "click": function($event) {
        _vm.unmarkLateError();
        _vm.toggleLate({
          value: true
        });
      },
      "update:valuebinder": function($event) {
        _vm.lateArrival = $event
      }
    }
  }), _vm._v(" "), _c('Checkbox', {
    class: {
      error: _vm.markLate
    },
    attrs: {
      "label": "NEJ",
      "label-position": "after",
      "value": false,
      "valuebinder": _vm.lateArrival
    },
    on: {
      "click": function($event) {
        _vm.unmarkLateError();
        _vm.toggleLate({
          value: false
        });
      },
      "update:valuebinder": function($event) {
        _vm.lateArrival = $event
      }
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.isSummerSeason) ? _c('div', {
    staticClass: "cancellation-insurance"
  }, [(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_title) ? _c('h3', [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1
    }
  }), _vm._v(" " + _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_title))], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info2) ? _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info2)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info3) ? _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info3)
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.cancellationInsuranceEnabled && _vm.cancellationInsuranceObject) ? _c('div', {
    staticClass: "cancellation-insurance"
  }, [_vm._m(1), _vm._v(" "), _c('h3', [_c('icon', {
    attrs: {
      "name": "avbestallning",
      "scale": 2
    }
  }), _vm._v(" Avbeställningskydd "), _c('em', [_vm._v(_vm._s(_vm._f("currency")(_vm.cancellationInsuranceObject.curraprice)))])], 1), _vm._v(" "), _c('p', [_vm._v("Branäsgruppen erbjuder ett av branschens mest generösa om- och avbokningsskydd. Det innebär att om du har köpt vårt om- och avbeställningsskydd kan du fritt omboka eller avboka fram tills dess att det är 20 dagar kvar till ankomst. Du behöver inget skäl eller intyg. När det är 20 dagar kvar eller mindre till ankomst kan du med ett giltigt skäl och ett intyg om- eller avboka mot en expeditionsavgift på 200 kr. Läs mer i våra bokningsregler. ")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.cancellationInsuranceObject.text)
    }
  }), _vm._v(" "), _c('p', [_c('Checkbox', {
    class: {
      error: _vm.markInsurance, 'non-clickable': _vm.cancellationInsuranceObject.free
    },
    attrs: {
      "label": "JA",
      "label-position": "after",
      "value": true,
      "valuebinder": _vm.cancellationInsurance
    },
    on: {
      "click": function($event) {
        return _vm.unmarkInsuranceError()
      },
      "update:valuebinder": function($event) {
        _vm.cancellationInsurance = $event
      }
    }
  }), _vm._v(" "), _c('Checkbox', {
    class: {
      error: _vm.markInsurance, disabled: _vm.cancellationInsuranceObject.free
    },
    attrs: {
      "label": "NEJ",
      "label-position": "after",
      "value": false,
      "valuebinder": _vm.cancellationInsurance
    },
    on: {
      "click": function($event) {
        return _vm.unmarkInsuranceError()
      },
      "update:valuebinder": function($event) {
        _vm.cancellationInsurance = $event
      }
    }
  })], 1), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "2em",
      "padding-bottom": "2em"
    }
  }, [_c('button', {
    class: {
      disabled: !_vm.validated()
    },
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  }, [_vm._v("Nästa")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "font-weight": "300",
      "font-size": "11px"
    }
  }, [_vm._v("För 4 personer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "required-notice"
  }, [_c('span', [_vm._v("*")]), _vm._v(" Obligatoriska fält")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb353b54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Accomodation/AddonsPage.vue
// module id = 1041
// module chunks = 0